var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngryCat = function SvgAngryCat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28 3.5c13.532 0 24.5 10.969 24.5 24.5S41.532 52.5 28 52.5 3.5 41.532 3.5 28 14.469 3.5 28 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M45.206 27.618c0 9.485-7.7 17.185-17.203 17.185s-17.202-7.7-17.202-17.185 7.7-17.22 17.202-17.22 17.203 7.7 17.203 17.202z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "m46.41 29.455-1.575 5.25a17.6 17.6 0 0 1-6.352 9.065 17.47 17.47 0 0 1-10.5 3.482A17.59 17.59 0 0 1 11.13 34.706l-1.575-5.25c-.21-.7.315-1.417 1.068-1.417H45.36c.735 0 1.278.717 1.068 1.417z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEFAFF",
    d: "M36.922 36.208c0 4.935-3.99 9.45-8.925 9.45s-8.925-4.515-8.925-9.45 3.99-7.49 8.925-7.49 8.925 2.555 8.925 7.49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M31.08 31.99c0 1.137-1.364 2.134-2.274 2.66-.508.28-1.12.28-1.628 0-.91-.543-2.275-1.523-2.275-2.66 0-1.698 1.383-2.363 3.098-2.363 1.697 0 3.08.665 3.08 2.363"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "m23.628 12.48.84 8.68-13.353 4.952v-15.61c0-1.26 1.313-2.118 2.468-1.61l8.487 3.762"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m20.105 15.682-5.652-2.992c-.228-.123-.508.052-.508.315V19.9c0 .28.315.455.543.297l5.652-3.902a.352.352 0 0 0-.035-.595z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "m32.374 12.48-.84 8.68 13.353 4.952v-15.61c0-1.26-1.313-2.118-2.468-1.61l-8.487 3.762"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m35.893 15.682 5.653-2.992c.227-.123.507.052.507.315V19.9c0 .28-.315.455-.542.297l-5.653-3.902a.352.352 0 0 1 .035-.595zM30.243 22.962a.76.76 0 0 1 .332-1.015l6.108-3.045a.76.76 0 0 1 1.015.332.76.76 0 0 1-.333 1.015l-6.107 3.045a.76.76 0 0 1-1.015-.332M37.384 25.379c0 1.47-1.19 2.66-2.66 2.66a2.644 2.644 0 0 1-2.643-2.66 2.64 2.64 0 0 1 2.643-2.643c1.452 0 2.66 1.19 2.66 2.643"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M36.158 24.975c-.21.14-.507 0-.682-.28s-.14-.596.052-.736c.21-.122.525 0 .683.28.175.28.14.613-.07.735z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M24.747 23.294 18.64 20.25a.753.753 0 0 1-.333-1.015.753.753 0 0 1 1.015-.332l6.108 3.045c.367.192.525.63.332 1.015a.76.76 0 0 1-1.015.332M18.621 25.379c0 1.47 1.19 2.66 2.66 2.66s2.643-1.19 2.643-2.66a2.64 2.64 0 0 0-2.643-2.643c-1.452 0-2.66 1.19-2.66 2.643"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M19.845 24.975c.21.14.508 0 .683-.28s.14-.596-.053-.736c-.21-.122-.525 0-.682.28-.175.28-.14.613.07.735z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M23.226 41.127a.85.85 0 0 1-.175-1.208c1.19-1.61 2.992-2.52 4.952-2.52s3.78.928 4.953 2.52a.88.88 0 0 1-.175 1.208.88.88 0 0 1-1.208-.175c-.857-1.155-2.152-1.82-3.57-1.82s-2.712.665-3.57 1.82a.85.85 0 0 1-1.207.175"
  })));
};
export default SvgAngryCat;